var _defs, _path, _path2, _path3, _path4, _path5, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPortal = function SvgPortal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1-del{fill:#fbd5cc;}.cls-1-del,.cls-2-del{fill-rule:evenodd;}.cls-2-del,.cls-3-del{fill:#ff8363;}.cls-4-del{isolation:isolate;}.cls-5-del{fill:#fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1-del",
    d: "M39.29,88.42a1.06,1.06,0,0,1-.62-1.92L89.13,49.88,38.67,13.26a1,1,0,0,1-.24-1.47,1.06,1.06,0,0,1,1.48-.24L91.55,49a1.07,1.07,0,0,1,0,1.71L39.91,88.21A1,1,0,0,1,39.29,88.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-del",
    d: "M61,18.68a10.37,10.37,0,1,0,6.41,9.59A10.36,10.36,0,0,0,61,18.68ZM57,36.53a8.26,8.26,0,1,1,8.26-8.26A8.26,8.26,0,0,1,57,36.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-del",
    d: "M74.19,47.7A4.52,4.52,0,1,0,77,51.87,4.51,4.51,0,0,0,74.19,47.7Zm-.81,6.39a2.4,2.4,0,1,1-.92-4.61,2.36,2.36,0,0,1,1.7.7,2.4,2.4,0,0,1-.78,3.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-del",
    d: "M55.6,55.35a6.73,6.73,0,1,0,6.72,6.73A6.72,6.72,0,0,0,55.6,55.35Zm0,11.35a4.62,4.62,0,1,1,4.61-4.62A4.63,4.63,0,0,1,55.6,66.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-del",
    d: "M28.31,66.55a5,5,0,0,1,5-5V0H0V99.81H33.27V71.5A5,5,0,0,1,28.31,66.55Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-del",
    cx: 33.27,
    cy: 66.54,
    r: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D-E-L",
    className: "cls-4-del"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4-del"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-del",
    d: "M23,14v2a11.83,11.83,0,0,1-.15,1.91,7.28,7.28,0,0,1-.52,1.78,5.27,5.27,0,0,1-1.13,1.6,5.42,5.42,0,0,1-2.09,1.29A8.2,8.2,0,0,1,16.5,23H10.08V5.2H16.5a8.2,8.2,0,0,1,2.61.41,5.61,5.61,0,0,1,3.22,2.86,7,7,0,0,1,.52,1.73A11.3,11.3,0,0,1,23,12.06Zm-3.48,0c0-.67,0-1.25,0-1.74s-.05-.92-.1-1.29a3.85,3.85,0,0,0-.23-.92,2.22,2.22,0,0,0-.4-.68,2.68,2.68,0,0,0-1.07-.82,3.7,3.7,0,0,0-1.53-.28H13.55V19.9h2.62a3.7,3.7,0,0,0,1.53-.28,2.68,2.68,0,0,0,1.07-.82,3.31,3.31,0,0,0,.62-1.68A26.67,26.67,0,0,0,19.52,14Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4-del"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-del",
    d: "M10.08,48V30.2H21.8v3.1H13.55v4.17h7v3.11h-7V44.9H21.8V48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4-del"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-del",
    d: "M10.08,73V55.2h3.47V69.9h8.07V73Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPortal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/portal.c97a5cfb.svg";
export { ForwardRef as ReactComponent };